<div id="map-wrapper" class="map-wrapper" style="position: relative; width: 100%; height: 100%;">
    <div id="esri-map-container" class='panel-body' style="width: 100%; height: 100%;">
        <div id="mapToolbar">
        
        	<!-- // Map search tools: geo shape, aoi, etc. -->
            <form class="navbar-form toolBtn" [ngClass]="{hide : !hide.hideTools}">
                <div ngbDropdown auto-close="outsideClick">
                    <button id="toolbarMenu" class="btn btn-warning" ngbDropdownToggle>
                        {{LOCALIZATION.tools}} <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" ngbDropdownMenu role="menu" aria-labelledby="toolbarMenu" style="min-width:64px">
                        <li role="menuitem" [ngClass]="{active : (mode == &quot;pan&quot;)}">
	                        <a class="pointMe" (click)="toggleMode(&quot;pan&quot;)" title="{{LOCALIZATION.panTo}}">
	                            <i class="far fa-hand-paper"></i>
	                        </a> 
                        </li>
                        <li role="menuitem" [ngClass]="{active : (mode == &quot;zoomin&quot;)}">
	                        <a class="pointMe" (click)="toggleMode(&quot;zoomin&quot;)" title="{{LOCALIZATION.zoomIn}}">
	                            <i class="fas fa-search-plus"></i>
	                        </a> 
                        </li>
                        <li role="menuitem" [ngClass]="{active : (mode == &quot;zoomout&quot;)}">
	                        <a class="pointMe" (click)="toggleMode(&quot;zoomout&quot;)" title="{{LOCALIZATION.zoomOut}}">
	                            <i class="fas fa-search-minus"></i>
	                        </a> 
                        </li>
                        <li role="menuitem" [ngClass]="{active : (mode == &quot;distance&quot;)}">
	                        <a class="pointMe" (click)="toggleMode(&quot;distance&quot;)" title="{{LOCALIZATION.distance}}">
	                            <i class="fas fa-ruler"></i>
	                        </a> 
                        </li>
                        <li role="menuitem" [ngClass]="{active : mode == (&quot;area&quot;)}">
	                        <a class="pointMe" (click)="toggleMode(&quot;area&quot;)" title="{{LOCALIZATION.area}}">
	                            <i class="fas fa-ruler-combined"></i>
	                        </a> 
                        </li>
                        <li role="menuitem" [hidden]="!tools.hasAOI">
                        	<a (click)="centerAOI()" title="{{LOCALIZATION.centerAOI}}" class="pointMe" (mouseover)="aoiOn()" (mouseleave)="aoiOff()">
                        		<i style="color:#229185;font-size:17px;" class="fa fa-bullseye" aria-hidden="true"></i>
                        	</a>
                        </li>
                        <li role="menuitem" [hidden]="!tools.hasAOI">
                        	<a (click)="clearAOI()" title="{{LOCALIZATION.clearAOI}}" (mouseover)="aoiOn()" (mouseleave)="aoiOff()">
                        		<i style="color:#d9534f;font-size:20px;" class="fa fa-times" aria-hidden="true"></i>
                        	</a>
                        </li>
                        <li role="menuitem" [hidden]="!tools.hasAOI">
                        	<a (click)="saveAOI()" title="{{LOCALIZATION.saveLocation}}" (mouseover)="aoiOn()" (mouseleave)="aoiOff()">
                        		<i style="color:#229185;font-size:17px;" class="fas fa-save" aria-hidden="true"></i>
                        	</a>
                        </li>	
                    </ul>
                </div>
            </form>
            
            <!-- // Map tools: pan, zoom, etc. -->
            <form class="navbar-form toolBtn" [ngClass]="{hide : hide.hideTools}">
                <div class="btn-group">
                    <button class="btn btn-default btn-sm map-tool-btn" 
	                    (click)="toggleMode(&quot;pan&quot;)" 
	                    [ngClass]="{shapeActive : (mode == &quot;pan&quot;)}" 
	                    title="{{LOCALIZATION.panTo}}">
                        	<i class="far fa-hand-paper"></i>
                    </button>
                    <button class="btn btn-default btn-sm map-tool-btn" 
	                    (click)="toggleMode(&quot;zoomin&quot;)" 
	                    [ngClass]="{shapeActive : (mode == &quot;zoomin&quot;)}" 
	                    title="{{LOCALIZATION.zoomIn}}">
                        	<i class="fas fa-search-plus"></i>
                    </button>
                    <button class="btn btn-default btn-sm map-tool-btn" 
	                    (click)="toggleMode(&quot;zoomout&quot;)" 
	                    [ngClass]="{shapeActive : (mode == &quot;zoomout&quot;)}" 
	                    title="{{LOCALIZATION.zoomOut}}">
                        	<i class="fas fa-search-minus"></i>
                    </button>
                    <button class="btn btn-default btn-sm map-tool-btn" 
	                    (click)="toggleMode(&quot;distance&quot;)" 
	                    [ngClass]="{shapeActive : mode == &quot;distance&quot;}" 
	                    title="{{LOCALIZATION.distance}}">
                        	<i class="fas fa-ruler"></i>
                    </button>
                    <button class="btn btn-default btn-sm map-tool-btn" 
	                    (click)="toggleMode(&quot;area&quot;)" 
	                    [ngClass]="{shapeActive : mode == &quot;area&quot;}" 
	                    title="{{LOCALIZATION.area}}">
                       		<i class="fas fa-ruler-combined"></i>
                    </button>
                    <button class="btn btn-default btn-sm map-tool-btn" 
	                    (click)="centerAOI()" 
	                    [hidden]="!tools.hasAOI" 
	                    (mouseover)="aoiOn()" 
	                    (mouseleave)="aoiOff()" 
	                    title="{{LOCALIZATION.centerAOI}}">
                        	<i class="fas fa fa-bullseye"></i>
                    </button> 
                    <button class="btn btn-default btn-sm map-tool-btn" 
	                    (click)="clearAOI()" 
	                    [hidden]="!tools.hasAOI" 
	                    (mouseover)="aoiOn()" 
	                    (mouseleave)="aoiOff()"
	                     title="{{LOCALIZATION.clearAOI}}">
                        	<i class="fas fa-times"></i>
                    </button>
                    <button class="btn btn-default btn-sm map-tool-btn" 
	                    (click)="saveAOI()" 
	                    [hidden]="!tools.hasAOI" 
	                    (mouseover)="aoiOn()" 
	                    (mouseleave)="aoiOff()" 
	                    title="{{LOCALIZATION.saveLocation}}">
                        	<i class="fas fa-save"></i>
                    </button>                    
                </div>
            </form>

			<!-- // Location search -->
            <form class="navbar-form toolBtn">
                <div class="dropdown" ngbDropdown auto-close="disabled">
                    <button class="btn btn-default btn-sm map-tool-btn dropdown-toggle" ngbDropdownToggle title="{{LOCALIZATION.searchGazeteer}}">
                        <i class="fa fa-search"></i>
                    </button>
                    <div class="dropdown-menu map-search" ngbDropdownMenu style="width:310px; height:auto; padding:10px; left:-120px;">
                        <div class="row" >
                            <div id="locationHolder" class="col-xs-12">
                            	<div id="mapLocationBar"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            
            <!-- // Detach -->
            <form class="navbar-form toolBtn">
                <div class="hidden-xs btn-group dropdown" *ngIf="!mapDetached">
                    <button class="btn btn-default btn-sm map-tool-btn" title="{{LOCALIZATION.detach}}" (click)="detachMap()">
                        <i class="fa fa-external-link-alt" ></i>
                    </button>
                </div>
            </form>            

<!-- // TODO: Chipping -->
<!--             <form class="hidden-xs navbar-form toolBtn"> -->
<!--                 <div *ngIf="chippingEnabled" class="dropdown" uib-dropdown auto-close="disabled"> -->
<!--                     <button class="btn btn-default btn-sm map-tool-btn dropdown-toggle" ngbDropdownToggle title="{{LOCALIZATION.chip}}"> -->
<!--                         <i class="fa fa-cut" ></i> -->
<!--                     </button> -->
<!--                     <div class="dropdown-menu " style="width:350px; max-height:60vh; overflow-y:auto; padding:10px; overflow-x:hidden; left:-180px;"> -->
<!--                         <div class="row text-center"> -->
<!--                             <div class="btn-group"> -->
<!--                                 <button class="btn btn-default" title="{{LOCALIZATION.boundTo}}" (click)="viewCoords =! viewCoords"> -->
<!--                                 	<i class="fa fa-thumbtack" aria-hidden="true" style="padding-right: 10px"></i><i class="fa" [ngClass]="{'fa-caret-down':!viewCoords, 'fa-caret-up':viewCoords}"></i> -->
<!--                                 </button> -->
<!--                                 <button class="btn btn-default" title="{{LOCALIZATION.clear}}" (click)="clearChipDraw()"> -->
<!--                                 	<i class="fa fa-eraser"></i> -->
<!--                                 </button> -->
<!--                                 <button class="btn btn-default" [ngClass]="{'btn-primary' : tools.activeShape == 'rectangle'}" title="{{LOCALIZATION.byRectangle}}" (click)="enableChipDraw()"> -->
<!--                                 	<i class="far fa-square"></i> -->
<!--                                 </button> -->
<!--                             </div> -->
<!--                         </div> -->
<!--                         <div *ngIf="viewCoords" class="row"> -->
<!--                             <div class="form-group col-xs-12"> -->
<!--                                 <label class="col-xs-3 control-label">y1</label> -->
<!--                                 <label class="col-xs-3 control-label">{{chip.y1.toFixed(2)}}</label> -->
<!--                                 <label class="col-xs-3 control-label">x1</label> -->
<!--                                 <label class="col-xs-3 control-label">{{chip.x1.toFixed(2)}}</label> -->
<!--                             </div> -->
<!--                             <div class="form-group col-xs-12"> -->
<!--                                 <label class="col-xs-3 control-label">y2</label> -->
<!--                                 <label class="col-xs-3 control-label">{{chip.y2.toFixed(2)}}</label> -->
<!--                                 <label class="col-xs-3 control-label">x2</label> -->
<!--                                 <label class="col-xs-3 control-label">{{chip.x2.toFixed(2)}}</label> -->
<!--                             </div> -->
<!--                         </div> -->
<!--                         <div class="row" > -->
<!--                             <div class="form-group col-xs-12"> -->
<!--                                 <label>{{LOCALIZATION.chipFormat}}</label> -->
<!--                                 <div> -->
<!--                                     <select class="form-control" [(ngModel)]="chip.chipFormat" > -->
<!--                                         <option ng-repeat="format in supportedChipFormats track by $index" value="{{format.value}}">{{format.display}}</option> -->
<!--                                     </select> -->
<!--                                 </div> -->
<!--                             </div> -->
<!--                         </div> -->
<!--                         <div class="row" > -->
<!--                             <div class="form-group col-xs-12"> -->
<!--                                 <label>{{LOCALIZATION.chipPackageType}}</label> -->
<!--                                 <div> -->
<!--                                     <select class="form-control" [(ngModel)]="chip.chipPackageType" > -->
<!--                                         <option ng-repeat="package in supportedPackageTypes track by $index" value="{{package.value}}">{{package.display}}</option> -->
<!--                                     </select> -->
<!--                                 </div> -->
<!--                             </div> -->
<!--                         </div> -->
<!--                         <div class="row"> -->
<!--                             <div class="form-group col-xs-12"> -->
<!--                                 <label>{{LOCALIZATION.chipRequestName}}</label> -->
<!--                                 <input class="form-control" type="text" [(ngModel)]="chip.chipRequestName"> -->
<!--                             </div> -->
<!--                         </div> -->
<!--                         <div class="row" *ngIf="(userPermissions['ROLE_USERS_EMAIL'])"> -->
<!--                             <div class="form-group col-xs-12"> -->
<!--                                 <label> -->
<!--                                     <input type="checkbox" [(ngModel)]="chip.chipEmailNotification"> {{LOCALIZATION.emailSend}} -->
<!--                                 </label> -->
<!--                             </div> -->
<!--                         </div> -->
<!--                         <div> -->
<!--                             <span *ngIf="chip.searchResults.length > 0 && !chip.searching">{{chip.selectedResultsArr.length}} {{LOCALIZATION.selected}}</span> -->
<!--                             <button *ngIf="chip.searchResults.length > 0 && !chip.searching" class="btn btn-xs btn-info" (click)="clearSelectedChipResult()">{{LOCALIZATION.clearSelected}}</button> -->
<!--                             <p *ngIf="chip.searching" class="text-center"><i class="fa fa-spinner fa-spin fa-2x fa-fw margin-bottom"></i></p> -->
<!--                             <ul class="list-group" style="max-height: 250px;overflow-x: hidden;overflow-y: auto;padding:5px"> -->
<!--                                 <li ng-repeat="result in chip.searchResults" [ngClass]="{'active':chip.selectedResults[result.id]}" class="row nomargins list-group-item pointMe" (click)="selectChipRecord(result.id)"> -->
<!--                                     <div class="col-xs-4"> -->
<!--                                     	<img class='img-responsive' [src]="result._thumbs" alt="Thumbnail for {{result.title}}" style="max-height:40px" /> -->
<!--                                     </div> -->
<!--                                     <div class="col-xs-8 truncate">{{result.title}}</div> -->
<!--                                 </li> -->
<!--                                 <li *ngIf="chip.searchResults.length == 0 && !chip.searching"><em>{{LOCALIZATION.chipDrawPrompt}}</em></li> -->
<!--                             </ul> -->
<!--                         </div> -->
<!--                         <ul *ngIf="chip.searchTotal > 0"  -->
<!-- 	                        uib-pager  -->
<!-- 	                        items-per-page='chip.pageSize'  -->
<!-- 	                        total-items="chip.searchTotal"  -->
<!-- 	                        [(ngModel)]="chip.pageIndex"  -->
<!-- 	                        class='custom-page'  -->
<!-- 	                        (change)='searchChipProducts()'  -->
<!-- 	                        style="display:inline-block;"  -->
<!-- 	                        previous-text="&#xf053;"  -->
<!-- 	                        next-text="&#xf054;"> -->
<!--                         </ul> -->
<!--                         <br> -->
<!--                         <div class="row"> -->
<!--                             <div class="form-group col-xs-12"> -->
<!--                                 <button class="btn btn-primary" [disabled]="!chip.chipFormat" (click)="performChip()">{{LOCALIZATION.chip}}</button> -->
<!--                             </div> -->
<!--                         </div> -->
<!--                     </div> -->
<!--                 </div> -->
<!--             </form> -->

			<!-- // Map base layers and settings -->
            <form class="navbar-form toolBtn">
                <div ngbDropdown auto-close="outsideClick">
                    <button style="margin-right:5px" id="mapSettingsBtn" title="{{LOCALIZATION.mapControls}}" [attr.aria-label]="LOCALIZATION.mapControls" class="btn btn-default btn-sm map-tool-btn" ngbDropdownToggle>
                        <i class="fas fa-cog"></i><span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" style="left:-150px;padding:20px" ngbDropdownMenu role="menu" aria-labelledby="mapSettingsBtn">
<!--                        // Overview map is not currently supported -->
<!--                         <div class="row"><div class="col-xs-12"> -->
<!--                             <span class="hidden-xs">{{LOCALIZATION.overview}}:</span> -->
<!--                             <div class="hidden-xs btn-group"> -->
<!--                                 <label class="btn btn-primary" (click)="toggleOverview(true);changingSettings();" [(ngModel)]="mapControl.overview" uib-btn-radio="true">{{LOCALIZATION.on}}</label> -->
<!--                                 <label class="btn btn-primary" (click)="toggleOverview(false);changingSettings();" [(ngModel)]="mapControl.overview" uib-btn-radio="false">{{LOCALIZATION.off}}</label> -->
<!--                             </div> -->
<!--                         </div></div> -->
                        <li role="separator" class="divider"></li>
                        <li style="text-align:center"> {{LOCALIZATION.mapBase}}
                            <br>
								<select [(ngModel)]="mapControl.baseMapUnit"
										name="basemap"
								        (change)="changingSettings()"
								        (click)="changeBasemap()">
									<option *ngFor="let basemap of basemapConfigs" [ngValue]="basemap.name">
								    	{{ basemap.displayName }}
								  	</option>
								</select>
                        </li>
                        <li style="text-align:center"> {{LOCALIZATION.lengthUnit}}
                            <br>
								<select [(ngModel)]="mapControl.lengthUnit"
										name="length"
								        (change)="changingSettings()">
									<option *ngFor="let length of lengthUnits" [ngValue]="length.engineUnit">
								    	{{ length.name }}
								  	</option>
								</select>
                        </li>
                        <li style="text-align:center"> {{LOCALIZATION.arealUnit}}
                            <br>
								<select [(ngModel)]="mapControl.arealUnit"
										name="area"
								        (change)="changingSettings()">
									<option *ngFor="let area of arealUnits" [ngValue]="area.apiValue">
								    	{{ area.name }}
								  	</option>
								</select>
                        </li>
                        <li style="text-align:center"> {{LOCALIZATION.fromProjection}}
                            <br>
								<select [(ngModel)]="mapControl.projectionUnit"
										name="projection"
								        (change)="changingSettings()">
									<option *ngFor="let projection of projectionUnits" [ngValue]="projection.value">
								    	{{ projection.name }}
								  	</option>
								</select>
                        </li>
                        <li style="text-align:center"> {{LOCALIZATION.selectedDocuments}}
                            <br>
								<select [(ngModel)]="mapControl.geometrySearchPredicate"
										name="predicate"
								        (change)="changingSettings(); updateGeometrySearchPredicate();"
								        style="width: 100%;">
									<option *ngFor="let predicate of geometrySearchPredicates" [ngValue]="predicate.value">
								    	{{ predicate.name }}
								  	</option>
								</select>
                        </li>
                    </ul>
                </div>
            </form>

			<!-- // External projection layers (do we need this?) -->
            <form class="navbar-form toolBtn">
                <div ngbDropdown auto-close="outsideClick">
                    <button id="mapLayersBtn" title="{{LOCALIZATION.mapLayers}}" [attr.aria-label]="LOCALIZATION.mapLayers" class="btn btn-default btn-sm map-tool-btn" ngbDropdownToggle>
                        <i class="fas fa-layer-group"></i> <span class="caret"></span>
                    </button>
                    <ul style="left:inherit" class="dropdown-menu dropdown-menu-right" ngbDropdownMenu role="menu" aria-labelledby="mapLayersBtn">
							<!--  TODO: replace js-tree with a tree of simple checkboxes -->
<!--                         <li class="layerControlli"> -->
<!--                             <button class="btn btn-xs btn-info" (click)="selectAllLayers()">{{LOCALIZATION.selectAll}}</button> -->
<!--                             <button class="btn btn-xs btn-danger" (click)="deselectAllLayers()">{{LOCALIZATION.selectNone}}</button> -->
<!--                         </li> -->
<!--                         <li role="separator" class="divider"></li> -->
							<!--  Original -->
<!--                         <div *ngIf="vm.treeData.length > 0"  -->
<!--                         	class="layerTree"  -->
<!--                         	js-tree="vm.treeConfig"  -->
<!--                         	[(ngModel)]="vm.treeData"  -->
<!--                         	tree="vm.treeInstance"  -->
<!--                         	tree-events="ready:vm.readyCB;check_node:vm.check_node;uncheck_node:vm.uncheck_node;"> -->
<!--                         </div> -->

							<!-- Replacement (in progress) -->
						  <div>Projections</div>
						  <div *ngFor="let layer of treeData; let i = index">
						    <label>
						      <input
						        type="checkbox"
						        [(ngModel)]="layer.checked"
						        name="checkbox{{ i }}" />
						      {{ layer.text }}
						    </label>
						  </div>
                    </ul>
                </div>
            </form>
        </div>

		<div id='mapViewDiv' style="width: 100%; height: 100%"></div>

    </div>
</div>
<div id='fullExtentButton' class="esriSimpleSlider esriSimpleSliderVertical esriSimpleSliderTL" style="z-index: 30;">
    <div title="{{LOCALIZATION.zoomFull}}" (click)='fullExtent()'>
        <i class="fas fa-globe-americas"></i>
    </div>
</div>
<div id='drawButtons' class="esriSimpleSlider esriSimpleSliderVertical esriSimpleSliderTL" style="z-index: 30;">
    <div class="esriSimpleSliderIncrementButton" title="{{LOCALIZATION.byRectangle}}" (click)='activeShape("rectangle")'>
        <i class="far fa-square" [ngClass]="{'shapeInactive' : tools.activeShape != 'rectangle', 'shapeActive' : tools.activeShape == 'rectangle'}"></i>
    </div>
    <div class="esriSimpleSliderIncrementButton" title="{{LOCALIZATION.byPolygon}}" (click)='activeShape("polygon")'>
        <i class="fa fa-draw-polygon" [ngClass]="{'shapeInactive' : tools.activeShape != 'polygon', 'shapeActive' : tools.activeShape == 'polygon'}"> </i>
    </div>
    <div class="esriSimpleSliderIncrementButton" title="{{LOCALIZATION.byCircle}}" (click)='activeShape("circle")'>
        <i class="far fa-circle" [ngClass]="{'shapeInactive' : tools.activeShape != 'circle', 'shapeActive' : tools.activeShape == 'circle'}"> </i>
    </div>
    <div class="esriSimpleSliderIncrementButton" title="{{LOCALIZATION.byPoint}}" (click)='activeShape("point")'>
        <i class="fa fa-map-marker-alt" [ngClass]="{'shapeInactive' : tools.activeShape != 'point', 'shapeActive' : tools.activeShape == 'point'}"></i>
    </div>
    <div class="esriSimpleSliderDecrementButton" title="{{LOCALIZATION.searchExtent}}" (click)='activeShape("extent")'>
        <i class="fa fa-crosshairs" [ngClass]="{'shapeInactive' : tools.activeShape != 'extent', 'shapeActive' : tools.activeShape == 'extent'}"></i>
    </div>
</div>



<div [draggableElem]="{ container: 'map-wrapper', draggable: true }" *ngIf="mapReady" class="draggable-panel" 
	style="left: 0; cursor: move; position: absolute; will-change: transform; transform: translateZ(0);">
  <div class="map-kv-record-preview preview-panel" [hidden]="!previewOpen">
		<map-record-preview [mapView]="mapView"></map-record-preview>
  </div>
  
<!--   Do we need this? -->
<!--     <div id="MissionExplorer" *ngIf="multigeometryLayer.graphics && multigeometryLayer.graphics.length > 1" [ngClass]='{"hide" : !sharedData.selectedMapRecord}'> -->
<!--         <div class="col-xs-12"> -->
<!--             <div> -->
<!--             	<button  -->
<!--             		title="Go to previous point"  -->
<!--             		[disabled]="!multigeometryLayer.graphics || currentMultiGeometry < 1"  -->
<!--             		(click)="goToPrevPoint()" class="btn btn-sm btn-primary"> -->
<!--             			<i class="fa fa-chevron-left" style="color:#fff"></i> -->
<!--             	</button> -->
<!--             	<span style="display:block">{{LOCALIZATION.previous}}</span> -->
<!--             </div> -->
<!--             <div> -->
<!--             	<button  --> 
<!--             		title="Go to next point"  -->
<!--             		[disabled]="!multigeometryLayer.graphics || currentMultiGeometry >= (multigeometryLayer.graphics.length-1)"  -->
<!--             		(click)="goToNextPoint()" class="btn btn-sm btn-primary"> -->
<!--             			<i class="fa fa-chevron-right" style="color:#fff"></i> -->
<!--             	</button> -->
<!--             	<span style="display:block">{{LOCALIZATION.next}}</span> -->
<!--             </div> -->
<!--         </div> -->
<!--     </div> -->  

</div> <!-- End draggable container  -->



<div id='MapNorthArrow'>
    <img [src]="'/app/aw-ui-angular/assets/img/cosd_north_arrow.webp'" style="height:45px" alt="Map north arrow">
</div>
<div id='coordinateSystem' 
	[hidden]='coordinates == null' 
	style='font-size:12px; bottom:3px; width:auto; background-color:white; left:15px; position:absolute; z-index:40;'>
    	{{LOCALIZATION.coordinates}} : {{coordinates}}
</div>
